// TODO: Revisit how this is done so we can do translation
export const PRISMA_ACCESS_CONTAINER = 'Prisma Access'
export const MU_CONTAINER = 'Mobile Users Container'
export const RN_CONTAINER = 'Remote Networks'
export const SC_CONTAINER = 'Service Connections'
export const MU_GP_CONTAINER = 'Mobile Users'
export const MU_JP_CONTAINER = 'Mobile Users'
export const MU_EP_CONTAINER = 'Mobile Users Explicit Proxy'
export const PRISMA_ACCESS_KEY = 'prisma-access'
export const MU_KEY = 'mobile-users'
export const RN_KEY = 'remote-networks'
export const SC_KEY = 'service-connections'
export const MU_GP_KEY = 'mobile-users-gp'
export const MU_JP_KEY = 'mobile-users-jp'
export const MU_GP_KEY_2 = 'mu-device'
export const MU_EP_KEY = 'mobile-users-ep'
export const CONTAINER = 'container'
export const CONTAINER_CLOUD = 'cloud'
export const CONTAINER_ONPREM = 'on-prem'
export const SWG_CONTAINER = 'web-security-config'
export const SWG_CONTAINER_TYPE = 'swg-container'
export const GPCS_CONTAINERS = {
  [PRISMA_ACCESS_KEY]: { name: PRISMA_ACCESS_CONTAINER, type: CONTAINER, locationPath: `${PRISMA_ACCESS_CONTAINER}` },
  [MU_KEY]: { name: MU_CONTAINER, type: CONTAINER, locationPath: `${MU_CONTAINER}` },
  [RN_KEY]: { name: RN_CONTAINER, type: CONTAINER_CLOUD, locationPath: `${RN_CONTAINER}` },
  [SC_KEY]: { name: SC_CONTAINER, type: CONTAINER_CLOUD, locationPath: `${SC_CONTAINER}` },
  [MU_GP_KEY]: { name: MU_GP_CONTAINER, type: CONTAINER_CLOUD, locationPath: `${MU_GP_CONTAINER}` },
  [MU_JP_KEY]: { name: MU_JP_CONTAINER, type: CONTAINER_CLOUD, locationPath: `${MU_JP_CONTAINER}` },
  [MU_GP_KEY_2]: { name: MU_GP_CONTAINER, type: CONTAINER_CLOUD, locationPath: `${MU_GP_CONTAINER}` },
  [MU_EP_KEY]: { name: MU_EP_CONTAINER, type: CONTAINER_CLOUD, locationPath: `${MU_EP_CONTAINER}` },
  [SWG_CONTAINER]: { name: SWG_CONTAINER_TYPE, type: SWG_CONTAINER_TYPE, locationPath: `${SWG_CONTAINER_TYPE}` },
}
